import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

class SubItems extends Component {
  constructor (props) {
    super()

    this.state = {}
  }

  MaxLength = value => (value.length > 30 ? value.substring(0, 29) : value)

  closeMenu = (index) => {
    var checkMenu = document.getElementById('menuToggle')
    this.props.displayMenu[this.props.index].display = false

    if (checkMenu && checkMenu.checked === true) {
      checkMenu.checked = false
    }
    this.props.callReset()
  }

  render () {
    return (
      this.props.displayMenu[this.props.index].display && (

        <div
          className={`subMenuToggle ${
            this.props.displayMenu[this.props.index].display ? 'active' : 'd-none'
          }`}
        >
          <ul className='txt-left radius px-0 py-0'>
            <li className='px-1 py-0 border-color-ui-3 border-bottom bg-brand-2 mb-1'>
              <div className='row align-items-center h-100 pos-relative'>
                <button
                  onClick={this.props.close(-1)}
                  className='btn btn-flat btn-sm btn-icon txt-font-body txt-body txt-font-body py-2 mx-1'
                >
                  <i className='icon icon_left_app icon-sm' />
                </button>
              </div>
            </li>

            {this.props.items.map(({ label, path }, ix) => (
              <li className='px-1 py-0 border-color-brand-5 h-100 item-menu-mobile'>
                <div className='row'>
                  <div className='col-12 px-0' onClick={() => {
                    this.closeMenu(this.props.index)
                  }}>
                    <Link role='link' to={path} className='btn btn-flat txt-font-body txt-body txt-initial txt-body txt-left py-half px-half link-font-mobile'>
                      <div className='row align-items-center h-100 pos-relative'>
                        <div className='col ml-2 pt-half'>{this.MaxLength(label)}</div>
                      </div>
                    </Link>
                  </div>
                </div>
              </li>
            ))}
            <li
              data-path={this.props.path}
              className={`px-1 py-0 border-color-brand-5 h-100 item-menu-mobile ${
                (!this.props.path || this.props.path) === '#' ? 'd-none' : ''
              }`}
            >
              <div className='row align-items-center pos-relative my-1 py-1 border-top border-color-ui-3' onClick={() => this.closeMenu()}>
                <Link
                  className='btn btn-flat btn-icon txt-font-body txt-initial txt-body'
                  to={this.props.path}
                >
                  <strong>Ver todas</strong>
                </Link>
              </div>
            </li>
          </ul>
        </div>
      )
    )
  }
}

SubItems.propTypes = {
  items: PropTypes.array.isRequired,
  // labelParent: PropTypes.string,
  displayMenu: PropTypes.array.isRequired,
  index: PropTypes.number.isRequired,
  path: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
  callReset: PropTypes.func.isRequired
}

SubItems.defaultProps = {
  path: '#'
}
export default SubItems



// WEBPACK FOOTER //
// ./src/App/MainMenu/MenuMobile/SubItems/SubItems.js